import React, { useEffect, useRef } from "react";

export default function VehicleUsers({ data, setActiveViewId }) {
	const containerRef = useRef(null);
	console.log(data)
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (containerRef.current && !containerRef.current.contains(event.target)) {
				setActiveViewId(null); // Close when clicking outside
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [setActiveViewId]);

	return (
		<div className="vehicle-users" ref={containerRef}>
			{data?.map((i) => (
				<div key={i?.id} className="text-center mb-3">
					{i?.username}
				</div>
			))}
		</div>
	);
}
